import { type QueryKey, useQueryClient } from '@tanstack/react-query';

const STABLE_AFTER_WRITE = new Set<unknown>(['bootstrap', 'reference']);

/** Session bootstrap and slow-changing reference data have explicit refresh paths; every other server query is refreshed after a domain write. */
export function shouldRefreshAfterWrite(queryKey: QueryKey) {
  return !STABLE_AFTER_WRITE.has(queryKey[0]);
}

/** After any write, refetch everything except the session and reference data (cheap: local API, small lists). */
export function useAfterWrite() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ predicate: (query) => shouldRefreshAfterWrite(query.queryKey) });
}
